import React, { useEffect, useState } from 'react';

import RowBuilder, { RowBuilderProps } from '../RowBuilder';
import { useField } from 'components/Common/Formik/hooks/useField';
import { fetcherWithBody } from 'services/fetcher';
import { apiUrls } from 'services/api-urls';
import { Field, TextField } from 'types/Field';
import { CustomerExistsType } from 'types/Customer';

type Props = RowBuilderProps;

export default function RowRepeatedEmail({
  field,
  styles,
}: Props): JSX.Element {
  const [emailCheckInitialize, setEmailCheckInitialize] = useState(false);
  const [emailExist, setEmailExist] = useState<boolean | null>(null);
  const [
    { value },
    { error: emailError },
    { setError, setValue },
  ] = useField<string>(field.name);

  const {
    type, // eslint-disable-line @typescript-eslint/no-unused-vars -- Extracted for non-reuse.
    repeatedType,
    secondName,
    secondLabel,
    secondId,
    secondPlaceholder,
    emailAlreadyUsedMessage,
    ...commonProps
  } = field as Extract<Field, { type: 'repeated' }>;

  const firstFieldProps = {
    ...commonProps,
    type: repeatedType,
  } as TextField;

  const secondFieldProps = {
    ...commonProps,
    type: repeatedType,
    name: secondName,
    label: secondLabel,
    id: secondId,
    placeholder: secondPlaceholder,
  };

  async function checkEmailExists(email: string): Promise<boolean> {
    const isExist = (await fetcherWithBody(apiUrls.getCustomerExists(), {
      email: email.toLowerCase(),
    })) as CustomerExistsType;

    return isExist.exists;
  }

  async function afterOnBlurEmail() {
    if (value && !emailError && null === emailExist) {
      const isExist = await checkEmailExists(value);

      setEmailExist(isExist);

      if (isExist) {
        setError(emailAlreadyUsedMessage);
      }
    }
  }

  useEffect(() => {
    if (emailCheckInitialize && null === emailExist) {
      setValue(value, true); // Solution to re-execute validator after state changed.
    }

    setEmailCheckInitialize(true);
  }, [emailExist]);

  return (
    <>
      <RowBuilder
        styles={styles}
        field={{
          ...firstFieldProps,
          onChange: (callback, value) => {
            setEmailExist(null);
            callback(value);
          },
          afterOnBlur: afterOnBlurEmail,
          validate: () => (emailExist ? emailAlreadyUsedMessage : undefined),
        }}
      />
      <RowBuilder styles={styles} field={secondFieldProps} />
    </>
  );
}
